import { render, staticRenderFns } from "./cookie-script-translation-modal.vue?vue&type=template&id=36bfc07c"
import script from "./cookie-script-translation-modal.vue?vue&type=script&lang=js"
export * from "./cookie-script-translation-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports